/**
 * BootScene — Minimal boot scene showing the game title.
 * Transitions to MainMenu after a brief delay (or immediately in test mode).
 */
import { Container, Text } from 'pixi.js';
import sceneManager from '../core/SceneManager.js';
import debugLog from '../debug/DebugLog.js';

export default class BootScene {
  constructor() {
    this.container = new Container();
    this._titleText = null;
    this._timer = null;
  }

  async init() {
    debugLog.info('BootScene: init');
  }

  async enter() {
    debugLog.event('BootScene: enter');

    // Title text
    this._titleText = new Text({
      text: 'Wanderlight',
      style: {
        fontFamily: 'Georgia, serif',
        fontSize: 64,
        fill: 0xffeedd,
        align: 'center',
        dropShadow: {
          color: 0x000000,
          blur: 8,
          distance: 4,
          angle: Math.PI / 4,
        },
      },
    });
    this._titleText.anchor.set(0.5);
    this.container.addChild(this._titleText);

    // Subtitle
    this._subtitleText = new Text({
      text: 'by Waystone Interactive',
      style: {
        fontFamily: 'Georgia, serif',
        fontSize: 20,
        fill: 0x8899aa,
        align: 'center',
      },
    });
    this._subtitleText.anchor.set(0.5);
    this.container.addChild(this._subtitleText);

    // Position in center (will be updated on resize)
    this._centerContent();

    // Transition to MainMenu
    const delay = window.__testMode ? 0 : 1000;
    this._timer = setTimeout(() => {
      sceneManager.transition('MainMenu');
    }, delay);
  }

  _centerContent() {
    const canvas = document.getElementById('game-canvas');
    const w = canvas ? canvas.clientWidth : 800;
    const h = canvas ? canvas.clientHeight : 600;

    if (this._titleText) {
      this._titleText.x = w / 2;
      this._titleText.y = h / 2 - 20;
    }
    if (this._subtitleText) {
      this._subtitleText.x = w / 2;
      this._subtitleText.y = h / 2 + 30;
    }
  }

  exit() {
    debugLog.event('BootScene: exit');
    if (this._timer) {
      clearTimeout(this._timer);
      this._timer = null;
    }
  }

  update(dt) {
    // No update logic needed for boot
  }

  resize(w, h) {
    this._centerContent();
  }
}
